// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"e2e76045","164":"951ce5a7","485":"6d2a7abb","550":"9c05a271","599":"0f1e5475","601":"e99def90","778":"56b5a1b6","825":"6bd762c6","863":"7c50545c","905":"d62d35fb","932":"1611decc","990":"34bf6440"}[chunkId] + ".chunk.js";
};